var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUwalk2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 70,
    viewBox: "0 0 62 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2878 7.65126C25.7379 7.65126 34.9743 0.567383 41.4554 0.567383C47.9364 0.567383 61.5479 4.35547 61.5479 34.67C61.5479 64.9846 43.2365 69.433 36.108 69.433C2.72665 69.435 -11.5324 7.65126 12.2878 7.65126Z",
    fill: "url(#paint0_linear_388_3857)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9073 14.2866C55.0443 14.2866 53.5281 12.7451 53.5281 10.8508C53.5281 8.95657 55.0443 7.41504 56.9073 7.41504C58.7704 7.41504 60.2865 8.95657 60.2865 10.8508C60.2865 12.7451 58.7704 14.2866 56.9073 14.2866ZM56.9073 9.70557C56.2878 9.70557 55.7809 10.2187 55.7809 10.8508C55.7809 11.483 56.2878 11.9961 56.9073 11.9961C57.5268 11.9961 58.0337 11.483 58.0337 10.8508C58.0337 10.2187 57.5268 9.70557 56.9073 9.70557Z",
    fill: "#D4D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2928 55.195V58.6308C48.2928 61.1618 46.2765 63.2118 43.7872 63.2118H20.1328C17.6435 63.2118 15.6273 61.1618 15.6273 58.6308V16.2559C15.6273 13.7248 17.6435 11.6748 20.1328 11.6748H43.7872C46.2765 11.6748 48.2928 13.7248 48.2928 16.2559V19.6917V55.195Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6273 55.1934V58.6292C15.6273 61.1602 17.6435 63.2102 20.1328 63.2102H43.7872C46.2765 63.2102 48.2928 61.1602 48.2928 58.6292V55.1934H15.6273Z",
    fill: "#A1AAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1328 58.6308V16.2559C20.1328 13.7248 22.1491 11.6748 24.6384 11.6748H20.1328C17.6435 11.6748 15.6273 13.7248 15.6273 16.2559V58.6308C15.6273 61.1618 17.6435 63.2118 20.1328 63.2118H24.6384C22.1491 63.2118 20.1328 61.1618 20.1328 58.6308Z",
    fill: "#F7F7F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1328 58.6292V55.1934H15.6273V58.6292C15.6273 61.1602 17.6435 63.2102 20.1328 63.2102H24.6384C22.1491 63.2102 20.1328 61.1602 20.1328 58.6292Z",
    fill: "#7B87FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_388_3857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8717 26.4697H43.6452V43.5303H40.8717V26.4697Z",
    fill: "#433ED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4186 29.3896H49.1921V43.4893H46.4186V29.3896Z",
    fill: "#433ED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.965 31.6172H54.7385V43.6019H51.965V31.6172Z",
    fill: "#433ED1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.512 34.084H60.2854V43.2488H57.512V34.084Z",
    fill: "#433ED1"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2929 56.9104H15.6273C14.6947 56.9104 13.9377 56.1408 13.9377 55.1925C13.9377 54.2442 14.6947 53.4746 15.6273 53.4746H48.2929C49.2255 53.4746 49.9824 54.2442 49.9824 55.1925C49.9824 56.1408 49.2255 56.9104 48.2929 56.9104Z",
    fill: "#433ED1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7873 64.9279H20.1329C16.7154 64.9279 13.9377 62.1037 13.9377 58.6289V16.254C13.9377 12.7793 16.7154 9.95508 20.1329 9.95508H43.7873C47.2048 9.95508 49.9824 12.7793 49.9824 16.254V23.6983H46.6033V16.254C46.6033 14.6759 45.3394 13.3909 43.7873 13.3909H20.1329C18.5808 13.3909 17.3169 14.6759 17.3169 16.254V58.6289C17.3169 60.2071 18.5808 61.4921 20.1329 61.4921H43.7873C45.3394 61.4921 46.6033 60.2071 46.6033 58.6289V46.6036H49.9824V58.6289C49.9824 62.1037 47.2048 64.9279 43.7873 64.9279Z",
    fill: "#433ED1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1581 26.8916C23.1581 27.8609 23.9339 28.655 24.8909 28.6652C25.8479 28.6755 26.6237 27.8981 26.6237 26.9288C26.6237 25.9596 25.8479 25.1655 24.8909 25.1552C23.9339 25.145 23.1581 25.9224 23.1581 26.8916Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3186 34.7598C29.3186 35.7291 30.0944 36.5231 31.0514 36.5334C32.0083 36.5436 32.7841 35.7662 32.7841 34.797C32.7841 33.8277 32.0083 33.0337 31.0514 33.0234C30.0944 33.0131 29.3186 33.7906 29.3186 34.7598Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6288 27.7608C31.6288 28.73 32.4046 29.5241 33.3615 29.5344C34.3185 29.5446 35.0943 28.7672 35.0943 27.798C35.0943 26.8287 34.3185 26.0346 33.3615 26.0244C32.4046 26.0141 31.6288 26.7915 31.6288 27.7608Z",
    fill: "#A7ABF0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6169 33.8946C21.6169 34.8638 22.3927 35.6579 23.3497 35.6681C24.3067 35.6784 25.0825 34.901 25.0825 33.9317C25.0825 32.9625 24.3067 32.1684 23.3497 32.1582C22.3927 32.1479 21.6169 32.9253 21.6169 33.8946Z",
    fill: "#A7ABF0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5793 26.8852C22.5793 25.595 23.6159 24.5563 24.8897 24.5699C26.1634 24.5836 27.2 25.6446 27.2 26.9347C27.2 28.2248 26.1634 29.2636 24.8897 29.2499C23.6159 29.2363 22.5793 28.1753 22.5793 26.8852ZM26.0448 26.9223C26.0448 26.2773 25.5265 25.7468 24.8897 25.7399C24.2528 25.7331 23.7345 26.2525 23.7345 26.8975C23.7345 27.5426 24.2528 28.0731 24.8897 28.0799C25.5265 28.0868 26.0448 27.5674 26.0448 26.9223Z",
    fill: "#433ED1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7403 34.7523C28.7403 33.4622 29.7769 32.4235 31.0507 32.4371C32.3244 32.4508 33.361 33.5118 33.361 34.8019C33.361 36.092 32.3244 37.1308 31.0507 37.1171C29.7769 37.1034 28.7403 36.0425 28.7403 34.7523ZM32.2058 34.7895C32.2058 34.1445 31.6876 33.614 31.0507 33.6071C30.4138 33.6003 29.8955 34.1197 29.8955 34.7647C29.8955 35.4098 30.4138 35.9403 31.0507 35.9471C31.6876 35.9539 32.2058 35.4346 32.2058 34.7895Z",
    fill: "#433ED1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.535 28.0869L30.2946 32.8855L29.3925 33.6071L25.6328 28.8085L26.535 28.0869Z",
    fill: "#433ED1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0511 27.7562C31.0511 26.4661 32.0876 25.4274 33.3614 25.441C34.6352 25.4547 35.6718 26.5157 35.6718 27.8058C35.6718 29.0959 34.6352 30.1347 33.3614 30.121C32.0876 30.1073 31.0511 29.0464 31.0511 27.7562ZM34.5166 27.7934C34.5166 27.1484 33.9983 26.6179 33.3614 26.611C32.7245 26.6042 32.2062 27.1236 32.2062 27.7686C32.2062 28.4137 32.7245 28.9442 33.3614 28.951C33.9983 28.9578 34.5166 28.4385 34.5166 27.7934Z",
    fill: "#433ED1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2013 40.975C27.2013 39.6849 28.2378 38.6461 29.5116 38.6598C30.7854 38.6735 31.822 39.7344 31.822 41.0246C31.822 42.3147 30.7854 43.3534 29.5116 43.3398C28.2378 43.3261 27.2013 42.2651 27.2013 40.975ZM30.6668 41.0122C30.6668 40.3671 30.1485 39.8366 29.5116 39.8298C28.8747 39.823 28.3564 40.3423 28.3564 40.9874C28.3564 41.6324 28.8747 42.1629 29.5116 42.1698C30.1485 42.1766 30.6668 41.6572 30.6668 41.0122Z",
    fill: "#433ED1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0398 33.8881C21.0398 32.598 22.0763 31.5592 23.3501 31.5729C24.6239 31.5865 25.6605 32.6475 25.6605 33.9376C25.6605 35.2278 24.6239 36.2665 23.3501 36.2528C22.0763 36.2392 21.0398 35.1782 21.0398 33.8881ZM24.5053 33.9253C24.5053 33.2802 23.987 32.7497 23.3501 32.7429C22.7132 32.736 22.1949 33.2554 22.1949 33.9005C22.1949 34.5455 22.7132 35.076 23.3501 35.0829C23.987 35.0897 24.5053 34.5703 24.5053 33.9253Z",
    fill: "#433ED1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4109 28.2852L32.0163 29.2885L25.2816 33.4113L24.6763 32.408L31.4109 28.2852Z",
    fill: "#433ED1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0513 35.0029L28.6512 39.1489L27.7872 39.9165L24.1872 35.7705L25.0513 35.0029Z",
    fill: "#433ED1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_388_3857",
    x: 40.8717,
    y: 26.4697,
    width: 19.7542,
    height: 17.1318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.340448
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.785833 0 0 0 0 0.798431 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_388_3857"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_388_3857",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_388_3857",
    x1: 30.9998,
    y1: 0.567383,
    x2: 30.9998,
    y2: 69.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F1FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F1FE",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUwalk2);
export default __webpack_public_path__ + "static/media/uwalk2.21c00fd441314a32de0a84f3365ef4c6.svg";
export { ForwardRef as ReactComponent };